import { compose, branch, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { sessionInitialized } from 'modules/session/selectors/sessionStatus';
import { showFooterTermsAndConditionsModal } from 'modules/auth/actions/termsOfService';

import TermsAndConditionsLink from './TermsAndConditionsLink';

const mapStateToProps = (state) => ({
  isSessionInitialized: sessionInitialized(state),
  showTermsAndConditions: state.auth.organizations.selectedOrganizationHasTermsAndConditions,
});

export default compose(
  connect(
    mapStateToProps,
    { showFooterTermsAndConditionsModal },
  ),
  branch(
    ({ isSessionInitialized, showTermsAndConditions }) => !isSessionInitialized || !showTermsAndConditions,
    renderNothing,
  ),
  injectIntl,
)(TermsAndConditionsLink);
